import styled, { css, keyframes } from 'styled-components';

export const Wrapper = styled.nav`
  ${({ theme, open }) => css`
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    transition: width 120ms ease-in-out;
    visibility: ${open ? 'visible' : 'hidden'};
    width: 100%;
    z-index: ${theme.v2.layers.important + 2};


    @media (min-width: ${theme.v2.breakpoints.md}){
      display: flex;
      flex-direction: column;
      flex: 1 0 auto;
      height: 100%;
      outline: none;
      overflow-y: auto;
      position: fixed;
      top: 0;
      visibility: visible;
      width: ${open ? '200px' : '64px'};
      z-index: 1200;
    }
  `}
`;

export const Overlay = styled.div`
  ${({ theme, open }) => css`
    background-color: ${theme.shadows.grey.darkest};
    height: 100%;
    left: 0;
    opacity: ${open ? 1 : 0};
    position: absolute;
    top: 0;
    transition: opacity 200ms ease-in-out;
    width: 100%;
    z-index: ${theme.layers.base};

    @media (min-width: ${theme.v2.breakpoints.md}){
      display: none;
      visibility: hidden;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme, open }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    box-shadow: 1px 0 3px ${theme.shadows.grey.light};
    display: flex;
    flex-direction: column;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    transform: translateX(${open ? '0' : '-100%'});
    transition: transform 200ms ease-in-out;
    width: 100vw;
    z-index: ${theme.layers.header};

    @media (min-width: ${theme.v2.breakpoints.md}){
      max-width: 100%;
      transform: translateX(0);
      width: 100%;
      overflow-x: hidden;
    }
  `}
`;

export const LogoButton = styled.button`
  ${({ theme, newMenu }) => css`
    background: none;
    border: 0 none;
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    padding: ${newMenu ? 0 : '32px'};
    width: 100%;

    svg {
      height: ${!newMenu && 'auto'};
      max-width: ${!newMenu && '141px'};
      width: ${!newMenu && '100%'};
    }

    @media (min-width: ${theme.v2.breakpoints.md}){
      justify-content: 'flex-start';
    }
  `}
`;

export const MyAccount = styled.div`
  ${({ theme }) => css`
    @media (min-width: ${theme.v2.breakpoints.md}){
      max-width: 100%;
      width: 100%;
    }

    @media (min-width: ${theme.v2.breakpoints.md}){
      display: none;
    }
  `}
`;

export const ListWrapper = styled.div`
  overflow: auto;

  &::-webkit-scrollbar {
    width: 1px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 1px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }
`;

export const List = styled.ul`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    list-style: none;
    margin: 0;
    padding: 0;

    @media (max-width: ${theme.breakpoints.md}) {
      li:nth-child(10) {
        margin-bottom: 24px;
      }

      li:last-child {
        margin-bottom 24px;
      }

      > li:last-child {
        margin-bottom 48px;
      }
    }
  `}
`;

export const Item = styled.li`
  ${({ theme, showInDevice }) => css`
    display: ${['mobile', 'both'].includes(showInDevice) ? 'block' : 'none'};
    margin-top: 0px;
    position: relative;

    &:before {
      border-top: 2px dotted ${theme.palette.primary.main};
      content: '';
      visibility: hidden;
      left: 30px;
      position: absolute;
      top: -2px;
      width: calc(100% - 60px);
    }

    &:last-child {
      margin-top: auto;
    }

    @media (min-width: ${theme.breakpoints.md}) {
      display: ${['desktop', 'both'].includes(showInDevice) ? 'block' : 'none'};
    }
  `}
`;

export const ButtonIcon = styled.span`
  display: flex;

  svg {
    transition: fill 200ms ease-in-out
  }
`;

export const ButtonText = styled.span`
  ${({ theme, variant }) => {
    const variants = {
      v2: {
        fontFamily: theme.v2.font.family.primary,
        fontSize: theme.v2.font.sizes.xxs,
        fontWeight: theme.v2.font.weights.medium,
        marginLeft: '10px',
        lineHeight: theme.v2.font.lineHeight.text,
      },
      v3: {
        fontFamily: theme.v2.font.family.primary,
        fontSize: theme.v2.font.sizes.xs,
        fontWeight: theme.v2.font.weights.medium,
        marginLeft: '10px',
        lineHeight: theme.v2.font.lineHeight.text,
      },
    };

    return css`
    align-items: center;
    display: flex;
    gap: 6px;
    font-family: ${variants[variant].fontFamily};
    font-size:  ${variants[variant].fontSize};
    font-weight: ${variants[variant].fontWeight};
    line-height: ${variants[variant].lineHeight};
    margin-left: ${variants[variant].marginLeft};
    text-align: left;
    transition: ${variant === 'v2' && 'color 200ms ease -in -out'};
  `;
  }}
`;

export const DropdownIcon = styled.span`
  display: flex;
  margin-left: 2px;
`;

export const Button = styled.button`${(
  {
    theme, active, open, variant, insideDropdown, onlyFillSvg, menuIsOpen,
  },
) => {
  const variants = {
    v2: {
      bgColor: theme.v2.colors.brand.menuPrimaryDark,
      padding: insideDropdown ? '17px 0px' : '16px 18px 16px 16px',
      visibility: 'visible',
      buttonColor: (active || open) ? `${theme.v2.colors.brand.primaryLight} !important` : theme.v2.colors.feedback.canceledPure,
      buttonColorHover: `${theme.v2.colors.brand.primaryLight} !important`,
      fontFamily: theme.v2.font.family.primary,
      activeColor: theme.v2.colors.brand.primaryLight,
    },
    v3: {
      bgColor: theme.v2.colors.neutral.highPure,
      padding: insideDropdown ? '17px 0px' : '16px 18px 16px 16px',
      visibility: 'visible',
      buttonColor: (active || open) ? `${theme.v2.colors.brand.primaryMedium} !important` : theme.v2.colors.neutral.lowDark,
      buttonColorHover: `${theme.v2.colors.brand.primaryBlue} !important`,
      fontFamily: theme.v2.font.family.primary,
      activeColor: theme.v2.colors.brand.primaryMedium,
    },
  };

  return css`
    align-items: center;
    background-color: ${variants[variant].bgColor};
    border: 0 none;
    display: flex;
    padding: ${!menuIsOpen ? '16px' : variants[variant].padding};
    position: relative;
    transition: background-color 200ms ease-in-out;
    width: 100%;

    @media (min-width: ${theme.v2.breakpoints.md}){
      justify-content: ${!menuIsOpen && 'center'};
    }

    &:before{
      width: 4px;
      background-color:${active ? variants[variant].activeColor : 'transparent'};
      left: 0px;
      top: 0px;
      position: absolute;
      height: 100%;
      content: ' ';
      border-radius: 0px 50px 50px 0px;
      visibility: ${active ? variants[variant].visibility : 'hidden'};
    }

    & ${ButtonText} {
      color: ${variant && variants[variant].buttonColor};
    }

    ${variant && variants[variant] && css`
      ${ButtonText} {
        color: ${variants[variant].buttonColor};
      }
      ${ButtonIcon} svg, svg {
        fill: ${onlyFillSvg && variants[variant].buttonColor};
      }
      ${ButtonIcon} svg path {
        stroke: ${!onlyFillSvg && variants[variant].buttonColor};
      }
    `};


    &:hover {
      cursor: pointer;

      ${variant && variants[variant] && css`
        ${ButtonText} {
          color: ${variants[variant].buttonColorHover};
        }
        ${ButtonIcon} svg, svg {
          fill: ${onlyFillSvg && variants[variant].buttonColorHover};
        }
        ${ButtonIcon} svg path {
          stroke: ${!onlyFillSvg && variants[variant].buttonColorHover};
        }
      `};
    }

    & ${DropdownIcon} {
      transform: rotate(${open ? '0deg' : '180deg'});
      transition: transform 200ms ease-in-out;

      svg {
        fill: ${variants[variant].buttonColor};
      }
    }
  `;
}}
`;

const tagShake = () => keyframes`
  0% { transform: rotate(0deg); }
  5% { transform: rotate(5deg); }
  10% { transform: rotate(0deg); }
  15% { transform: rotate(-5deg); }
  20% { transform: rotate(0deg); }
`;

export const Tag = styled.span`${({
  theme, tagInText, variant, shake,
}) => {
  const variants = {
    v2: {
      backgroundColor: theme.v2.colors.feedback.attentionLight,
      borderRadius: '50vh',
      color: theme.v2.colors.brand.primaryExtraDark,
      fontSize: theme.v2.font.sizes.xs,
      minHeight: '24px',
      padding: ' 4px 16px',
    },
    v3: {
      backgroundColor: theme.v2.colors.brand.primaryLowLight,
      borderRadius: '4px',
      color: theme.v2.colors.brand.primaryExtraDark,
      fontSize: theme.v2.font.sizes.xxs,
      minHeight: '24px',
      padding: '0px 8px',
    },
  };

  return css`
    -webkit-animation: ${shake && tagShake} 2s infinite linear;
    align-items: center;
    animation-iteration-count: infinite;
    animation: ${shake && tagShake} 2s infinite linear;
    background-color: ${variants[variant].backgroundColor};
    border-radius: ${variants[variant].borderRadius};
    bottom: 15px;
    color: ${variants[variant].color};
    display: flex;
    font-size: ${variants[variant].fontSize};
    justify-content: center;
    margin: ${variants[variant].margin};
    min-height: ${variants[variant].minHeight};
    padding: ${variants[variant].padding};
    position: ${tagInText ? 'inherit' : 'absolute'};
    right: 18px;
    width: fit-content;

    @media(max-width: ${theme.v2.breakpoints.md}) {
      margin-left: 8px;
    }
  `;
}}`;

export const TagNew = styled.span`
  ${({ tagInText, shake }) => css`
    position: ${tagInText ? 'inherit' : 'absolute'};
    -webkit-animation: ${shake && tagShake} 2s infinite linear;
    animation-iteration-count: infinite;
    animation: ${shake && tagShake} 2s infinite linear;
    right: 18px;
    width: fit-content;
    display: flex;
  `}
`;

export const Dropdown = styled.ul`
  ${({ open }) => css`
    max-height: ${open ? '305px' : 0};
    overflow: hidden;
    list-style: none;
    margin: 0;
    padding: 0;
    transition: 200ms ${open ? 'ease-in' : 'ease-out'};

    & ${Button} {
      padding: 8px 17px;
    }
  `}
`;

export const DropdownItem = styled.li`
  &:last-child ${Button} {
      padding-bottom: 15px;
  }
`;

export const CloseWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: absolute;
    right: 16px;
    top: 16px;

    @media (min-width: ${theme.v2.breakpoints.md}){
      visibility: hidden;
      display: none;
    }
  `}
`;

export const MenuHeader = styled.div`
  ${({ theme, menuIsOpen }) => css`
    align-items: flex-start;
    display: flex;
    gap: ${menuIsOpen ? '6px' : 0};
    padding: ${menuIsOpen ? '32px' : '28px 16px 32px 16px'};
    transition: width 120ms ease-in-out;
    width: ${menuIsOpen ? '202px' : '64px'};

    & > button:first-of-type {
      width: ${!menuIsOpen && '0px'};
    }

    span {
      cursor: pointer;
    }

    @media (min-width: ${theme.v2.breakpoints.md}){
      justify-content: center;
      padding: ${menuIsOpen ? '32px 16px' : '28px 16px 32px 16px'};
    }
  `}
`;

export const ArrowMinimizeMenuWrapper = styled.div`
  ${({ menuIsOpen }) => css`
    align-items: center;
    display: flex;
    justify-content: center;

    svg {
      transform: rotate(${menuIsOpen ? '0deg' : '180deg'});
      transition: transform 120ms ease-in-out;
    }
  `}
`;
